export default __webpack_public_path__ + "static/media/zenodo-connect.4bcc4cc6.png";